import React, { useState, useEffect } from "react";
import axios from "axios";
import "./ScheduleNotification.css";
import BASE_URL from "../../../../config/apiConfig";

const ScheduleNotification = () => {
  const [notifications, setNotifications] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editNotification, setEditNotification] = useState(null);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [scheduleTime, setScheduleTime] = useState("");
  const [currentNotificationId, setCurrentNotificationId] = useState(null);

  // Fetch notifications on component mount
  useEffect(() => {
    fetchNotifications();
  }, []);

  // Fetch notifications from the API
  const fetchNotifications = async () => {
    try {
      const { data } = await axios.get(
        `${BASE_URL}/api/admin/notifications/get-all-notifications`
      );

      // Log the number of sent notifications in the console
      const sentCount = data.filter(
        (notification) => notification.sentStatus
      ).length;
      // console.log(`Total sent notifications: ${sentCount}`);

      // Calculate time left for scheduled notifications
      const updatedNotifications = data.map((notification) => {
        if (notification.scheduled_time && !notification.sentStatus) {
          const timeLeft = calculateTimeLeft(notification.scheduled_time);
          return { ...notification, timeLeft };
        }
        return notification;
      });

      setNotifications(updatedNotifications);
    } catch (err) {
      console.error("Failed to fetch notifications", err);
    }
  };

  // Calculate time left for scheduled notifications
  const calculateTimeLeft = (scheduled_time) => {
    const scheduledDate = new Date(scheduled_time);
    const now = new Date();
    const timeDiff = scheduledDate - now;

    if (timeDiff <= 0) return "Sent"; // If the time has passed, return "Sent"

    const hours = Math.floor(timeDiff / (1000 * 60 * 60));
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    return `${hours}h ${minutes}m left`;
  };

  // Delete a notification
  const handleDelete = async (id) => {
    try {
      await axios.delete(
        `${BASE_URL}/api/admin/notifications/delete-notification/${id}`
      );
      fetchNotifications();
    } catch (err) {
      console.error("Failed to delete notification", err);
    }
  };

  // Send a notification immediately
  const handleSendNow = async (id) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/notifications/send/${id}`
      );
      console.log(`Notification sent for ID: ${id}`);
      alert(response.data.message);
      fetchNotifications();
    } catch (err) {
      if (err.response && err.response.status === 400) {
        alert(err.response.data.error); // Show the 24-hour rule error message
      } else {
        console.error("Failed to schedule notification", err);
        alert("Failed to schedule notification.");
      }
    }
  };

  // Open the schedule modal for a specific notification
  const handleSchedule = (id) => {
    setCurrentNotificationId(id);
    setShowScheduleModal(true);
  };

  // Schedule a notification
  const handleScheduleSubmit = async () => {
    if (!scheduleTime) {
      alert("Please enter a valid schedule time.");
      return;
    }
    console.log(scheduleTime);
    

    // Validate the scheduledTime format (ISO 8601: YYYY-MM-DDTHH:MM)
    const isoFormatRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;
    if (!isoFormatRegex.test(scheduleTime)) {
      alert(
        "Invalid scheduled time format. Please use the format YYYY-MM-DDTHH:MM."
      );
      return;
    }

    try {
      const response = await axios.post(
        `${BASE_URL}/api/admin/notifications/ScheduledNotifications`,
        {
          id: currentNotificationId,
          scheduledTime: scheduleTime,
        }
      );

      alert(response.data.message);
      setShowScheduleModal(false);
      setScheduleTime("");
      fetchNotifications();
    } catch (err) {
      if (err.response) {
        if (err.response.status === 400) {
          alert(err.response.data.error);
          console.log(err.response.data.error);
        } else if (err.response.status === 500) {
          alert("Internal server error. Please try again later.");
        } else {
          alert(`Error: ${err.response.status} - ${err.response.data.error}`);
        }
      } else {
        console.error("Network error or no response from the server", err);
        alert("Failed to schedule notification. Please try again.");
      }
    }
  };




  // Open the notification form for adding or editing
  const openForm = (notification = null) => {
    setEditNotification(notification);
    setShowForm(true);
  };

  // Close the notification form
  const closeForm = () => {
    setEditNotification(null);
    setShowForm(false);
    fetchNotifications();
  };

  return (
    <div className="schedule-notification">
      <div className="header">
        <h1>Scheduled Notifications</h1>
        <button className="add-button" onClick={() => openForm()}>
          Add New Notification
        </button>
      </div>

      {showForm && (
        <NotificationForm notification={editNotification} onClose={closeForm} />
      )}

      <div className="notification-list">
        {notifications.map((notification) => (
          <div key={notification.id} className="notification-card">
            <h3>{notification.title}</h3>
            <p>{notification.body}</p>
            {notification.image_url && (
              <img src={notification.image_url} alt={notification.title} />
            )}
            <div className="card-actions">
              <button
                className="send-now-button"
                onClick={() => handleSendNow(notification.id)}
              >
                Send Now
              </button>
              <button
                className="schedule-button"
                onClick={() => handleSchedule(notification.id)}
              >
                Schedule
              </button>
              <div className="menu">
                <button className="menu-button">⋮</button>
                <div className="menu-options">
                  <button onClick={() => openForm(notification)}>Edit</button>
                  <button onClick={() => handleDelete(notification.id)}>
                    Delete
                  </button>
                </div>
              </div>
            </div>
            {/* {notification.timeLeft && (
              <div className="time-left">
                {notification.timeLeft === "Sent"
                  ? "Notification Sent"
                  : notification.timeLeft}
              </div>
            )} */}
          </div>
        ))}
      </div>

      {showScheduleModal && (
        <div className="modal">
          <div className="modal-content">
            <h2>Schedule Notification</h2>
            <label>
              Enter the scheduled time (YYYY-MM-DD HH:MM):
              <input
                type="datetime-local"
                value={scheduleTime}
                onChange={(e) => setScheduleTime(e.target.value)} // Update state on change
                placeholder="2024-12-22 10:30"
              />
            </label>
            <div className="form-actions">
              <button
                type="button"
                onClick={() => setShowScheduleModal(false)} // Close modal on cancel
                className="cancel-button"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleScheduleSubmit} // Handle form submission
                className="save-button"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// NotificationForm Component for adding/editing notifications
const NotificationForm = ({ notification, onClose }) => {
  const [formData, setFormData] = useState({
    title: notification?.title || "",
    body: notification?.body || "",
    imageUrl: notification?.image_url || "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (notification) {
        await axios.put(
          `${BASE_URL}/api/admin/notifications/update-notification/${notification.id}`,
          formData
        );
      } else {
        await axios.post(
          `${BASE_URL}/api/admin/notifications/create-notification`,
          formData
        );
      }
      onClose();
    } catch (err) {
      console.error("Failed to save notification", err);
    }
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <h2>{notification ? "Edit Notification" : "Add New Notification"}</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Title"
            value={formData.title}
            onChange={(e) =>
              setFormData({ ...formData, title: e.target.value })
            }
            required
          />
          <textarea
            placeholder="Body"
            value={formData.body}
            onChange={(e) => setFormData({ ...formData, body: e.target.value })}
            required
          />
          <input
            type="text"
            placeholder="Image URL"
            value={formData.imageUrl}
            onChange={(e) =>
              setFormData({ ...formData, imageUrl: e.target.value })
            }
          />
          <div className="form-actions">
            <button type="button" onClick={onClose} className="cancel-button">
              Cancel
            </button>
            <button type="submit" className="save-button">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ScheduleNotification;
